export default __webpack_public_path__ + "images/0x894134a25a5fac1c2c26f1d8fbf05111a3cb9487.png";